<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'

export default {
    props: ['data'],
    name: "imagesSwiper",
    data() {
        return {
            swiperOptions: {
                slidesPerView: 'auto',
                spaceBetween: '1.25%',
                loop: true,
                navigation: {
                    nextEl: '.images_swiper .swiper-button-next',
                    prevEl: '.images_swiper .swiper-button-prev',
                },
            },
            isShowButton: true,
        };
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },
    directives: {
        swiper: directive
    },
    components: {
        Swiper,
        SwiperSlide
    },
    mounted() {},
    destroyed() {},
    watch: {
        data: {
            handler: 'dataChange',
            immediate: true
        }
    },
    methods: {
        dataChange() { 
            this.$nextTick(() => {
                if (this.data.length <= 1) { 
                    this.isShowButton = false;
                } else if (this.data.length > 1) {
                    this.isShowButton = true;
                }
            })
        }
    },
};
</script>

<template>
    <div class="layout_swiper images_swiper">
        <swiper ref="mySwiper" :options="swiperOptions" v-if="data.length > 0">
            <swiper-slide v-for="(item, index) in data" :key="index">
                <a v-if="item.link" :href="item.link" target="_blank">
                    <div class="cover" :style="`background-image: url(${item.image})`"></div>
                    <div class="text" v-if="item.name || item.desc">
                        <div class="name" v-if="item.name">{{ item.name }}</div>
                        <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                    </div>
                </a>
                <template v-else>
                    <div class="cover" :style="`background-image: url(${item.image})`"></div>
                    <div class="text" v-if="item.name || item.desc">
                        <div class="name" v-if="item.name">{{ item.name }}</div>
                        <div class="desc" v-if="item.desc">{{ item.desc }}</div>
                    </div>
                </template>
            </swiper-slide>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
        </swiper>
        <div class="swiper-button-prev" :class="{'swiper-button-disabled': !isShowButton}"></div>
        <div class="swiper-button-next" :class="{'swiper-button-disabled': !isShowButton}"></div>
    </div>
</template>

<style scoped lang="scss">
.images_swiper{
    position: relative;
    .swiper-slide{
        width: 3.9rem;
        height: 2.77rem;
        @media only screen and (max-width: 750px) {
            width: 100%;
            height: auto;
        }
        .cover{
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            @media only screen and (max-width: 750px) {
                height: 4.25rem;
            }
        }
        .text{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--reda);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            opacity: 0;
            transition: opacity .5s;
            .name{
                font-size: .3rem;
            }
            .desc{
                font-size: .2rem;
            }
            @media only screen and (max-width: 750px) {
                position: relative;
                opacity: 1;
                height: auto;
                padding: .3rem 0;
            }
        }
        &:hover{
            .name{
                opacity: 1;
            }
        }
    }
}
</style>